module.exports = __webpack_public_path__ + "static/media/SkullGirl1024881.b59df687.png";